export const metroAreas = [
  {
    id: 1,
    title: 'San Francisco Bay Area',
  },
  {
    id: 1840034016,
    title: 'New York',
  },
  {
    id: 1840013660,
    title: 'Atlanta',
  },
  {
    id: 1840000494,
    title: 'Chicago',
  },
  {
    id: 1840000455,
    title: 'Boston',
  },
  {
    id: 1840021117,
    title: 'Seattle',
  },
  {
    id: 1840019590,
    title: 'Austin',
  },
  {
    id: 1840018789,
    title: 'Denver',
  },
  {
    id: 1840020568,
    title: 'Phoenix',
  },
  {
    id: 1124279679,
    title: 'Toronto',
  },
];
